import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'

import { _ } from '../../functions/translator.js';
import { addCards, 
        popupChange,
        popUpMenuChange,
        popUpMessageChange,
        selectedCardsGroupsChange, 
        toggleSwitch } from '../../actions'
import Button from '@material-ui/core/Button';

import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';
import { cardsGroupStates, 
        CardsGroupStatus, 
        colorClasses, 
        ToggleActions } from '../../constants/constants.js';
import { cardsExist } from '../../functions/finder.js';
import { getCardsData } from '../../functions/getData.js';
import { showMessage } from '../../functions/popUpMessage';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups.js';

class CardsGroupInfo extends React.Component{
    
    removeCardsGroup = (cardsGroupId) => {
        let filteredCardsGroupIds = []
        this.props.selectedCardsGroups.forEach(selectedCardsGroupId => {
            if (selectedCardsGroupId !== cardsGroupId) {
                filteredCardsGroupIds.push(selectedCardsGroupId)
            }
        })
        this.props.selectedCardsGroupsChange(filteredCardsGroupIds)
        if (filteredCardsGroupIds.length === 0) {
            this.props.popUpMenuChange({ 
                show: false, 
                close: false, 
                closeList: false,
                expanded: false,
                opacity: 1 
            })
        }
    }

    handleViewMore = async () => {
        if (this.props.cardsGroupData.attributes.status === CardsGroupStatus.STAND_BY) {
            this.props.popupChange({
                cardsGroup: this.props.cardsGroupData
            })
        } else {
            let cardsData
            if (cardsExist(this.props.cardsGroupData)) {
                cardsData = this.props.cardsGroupData.cards
            } else {
                let cardsGroupId = this.props.cardsGroupData.id
                this.props.toggleSwitch(ToggleActions.CARDS_LOADING)
                cardsData = await getCardsData(cardsGroupId)
                this.props.toggleSwitch(ToggleActions.CARDS_LOADING)
                if (typeof cardsData === 'undefined') return
                this.props.addCards({ 
                    id: cardsGroupId,  
                    cards: cardsData
                })
            }
            const cardsArray = Object.values(cardsData)
            this.props.popupChange({
                card: cardsArray[cardsArray.length - 1],
                cardsGroup: this.props.cardsGroupData
            })
        }
    }

    handleCloseProtocol = async () => {
        const message = '¿' + _('Seguro que deseas cerrar este protocolo') + '?';
        const messageConfig = {
            closeButton: true,
            closeConfirm: true,
            cardsGroupIds: this.props.cardsGroupData.id
        }
        showMessage(this.props, message, messageConfig);
        // this.props.popUpMenuChange({ 
        //     show: false,
        //     expanded: false,
        // });
        //this.props.selectedCardsGroupsChange([]);
    }

    handleResponse = (response) => {
        if (response.status === 'success') {
            showMessage(this.props, '¡' + _('Protocolo Cerrado exitosamente') + '!');
            reloadCardsGroupsFeatures(this.props, this.props.cardsGroupIds);
        } else {
            showMessage(this.props, _('Ocurrió un error al cerrar el protocolo'));
        }
    }

    render() {
        let protocolId = this.props.cardsGroupData.attributes.protocol_id
        let protocolName = ''
        let protocolGroupName = ''
        if (protocolId) {
            protocolId = protocolId.toString()
            Object.values(this.props.projectData.protocolgroups).forEach(protocolGroup => {
                if (Object.keys(protocolGroup.protocols).includes(protocolId)) {
                    protocolGroupName = protocolGroup.attributes.name
                    protocolName = protocolGroup.protocols[protocolId].attributes.name
                }
            })
        }
        let protocolTotalName = protocolGroupName + ' - ' + protocolName
        let description = protocolTotalName;
        
        if (this.props.cardsGroupData.attributes.first_card_description) {
            description = this.props.cardsGroupData.attributes.first_card_description;
        }
        if (!protocolId) {
            if (description === ' - ') {
                let customCardName = this.props.projectData.customcards[this.props.cardsGroupData.attributes.customcard_id].attributes.name
                if (customCardName) {
                    description = customCardName
                }
                let customCardFields = this.props.projectData.customcards[this.props.cardsGroupData.attributes.customcard_id].customcardfields
                let notEmptyCustomCardFields = Object.values(customCardFields).filter(c => {if(c != {}) return c})
                if(notEmptyCustomCardFields.length > 0) {
                    let fistNotEmptyCustomCardField = notEmptyCustomCardFields[0]
                    if (fistNotEmptyCustomCardField) {
                        let referenceField = fistNotEmptyCustomCardField.attributes.reference_field
                        let referenceFieldValue = this.props.projectData.cards_groups[this.props.cardsGroupData.id].attributes[referenceField]
                        if (referenceFieldValue) {
                            description = description + ' - ' + referenceFieldValue
                        }
                    }
                }
            }
        }
        let classColor = colorClasses[this.props.cardsGroupData.attributes.status]
        let cardsUrl = '/cards?project_id=' + window.project_id
        cardsUrl += '&cards_group_id=' + this.props.cardsGroupData.id.toString()

        return (
            <tr>
                <td className='p-0'>
                    <Button
                        size="small"
                        variant="contained"
                        onClick={() => {this.removeCardsGroup(this.props.cardsGroupData.id)}}
                        className='remove-button'>
                        <Icon path={ mdiClose } size='25px'/>
                    </Button>
                </td>
                { this.props.popUpMenu.expanded ? <td>{ this.props.cardsGroupData.attributes.index }</td> : null }
                <td className='protocol-name-container'>{ description }</td>
                <td>
                    <label class={`badge badge-outline-${classColor} ml-3`}>
                        {cardsGroupStates[this.props.cardsGroupData.attributes.status]}
                    </label>
                </td>
                { this.props.popUpMenu.expanded ?
                <td>
                    <div>
                        <p className="center my-0">
                            <Button
                                variant="contained"
                                disabled={!this.props.userRole.update_cards_group_status || 
                                        (this.props.cardsGroupData.attributes.status !== CardsGroupStatus.IN_PROGRESS
                                        && this.props.cardsGroupData.attributes.protocol_id)}
                                onClick={() => {
                                    if (this.props.userRole.update_cards_group_status && 
                                        (this.props.cardsGroupData.attributes.status === CardsGroupStatus.IN_PROGRESS || !this.props.cardsGroupData.attributes.protocol_id)) {
                                        this.handleCloseProtocol();
                                    }
                                }}
                                >
                                {_('Cerrar')}
                            </Button>
                        </p>
                    </div>
                </td> : null }
                { this.props.popUpMenu.expanded ?
                <td>
                    <div>
                        <p className="center my-0">
                            <Button
                                variant="contained"
                                href={cardsUrl}
                                target='_blank'>
                                {_('Revisar')}
                            </Button>
                        </p>
                    </div>
                </td> : null }
                { this.props.popUpMenu.expanded ?
                <td>
                    <div>
                        <p className="center my-0">
                            <Button
                                variant="contained"
                                onClick={ this.handleViewMore }>
                                {`+ ${_('Ver Más')}`}
                            </Button>
                        </p>
                    </div>
                </td> : null }
            </tr>
        );

    }
}

function mapStateToProps( state ){
    return {
        projectData : state.projectData,
        popUpMenu : state.popUpMenu,
        selectedCardsGroups : state.selectedCardsGroups,
        userRole            : state.userRole,
    }
}

function matchDispatchToProps( dispatch ){
  return bindActionCreators({ 
        popupChange : popupChange,
        popUpMenuChange : popUpMenuChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        addCards : addCards,
        toggleSwitch : toggleSwitch,
        popUpMessageChange : popUpMessageChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(CardsGroupInfo)
